import type { ModuleDefinition } from '../types';

export const reportsModule: ModuleDefinition = {
  key: 'reports',
  milestone: 'M14',
  network: { path: 'reports', permission: 'report.read', labelKey: 'reports' },
  tenant: { path: 'reports', permission: 'report.read', labelKey: 'reports' },
  load: () => import('./ReportsModule'),
};
